// Module
var code = "<qr-code-generator ng-model=\"data[component.key]\" options=\"component.settings.options\"></qr-code-generator> ";
// Exports
export default code;